import Vue from 'vue';
import pTrans from './../../transformers/productWarehouse';

const success = ({ data }, resolve) => {
  const product = pTrans.fetchCollection(data);
  resolve(product);
};

const failed = () => {};

export default (productIds, warehouseId) => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`/stocks/find-product/${warehouseId}`, {
      product_ids: productIds,
    })
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/stock/warehouseProducts.js